// Components
import { FooterMenu, Loading } from "components"
import { FormSection, Journal } from "./components"

// Form
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"

// Third-Party Libraries
import moment from "moment"
import toast from "react-hot-toast"
import { useNavigate, useParams } from "react-router-dom"

// Utils
import { useApi } from "utils"
import { type FormType, useDetail, validationSchema, receiveType } from "./utils"

export default function ReceivedReject(): JSX.Element {
  // Hooks
  const api = useApi()
  const navigate = useNavigate()
  const { id } = useParams()
  const { data, isLoading } = useDetail(id!)

  // Form
  const defaultValues: FormType = {
    memo: "",
    referensi: "",
    transaction_date: moment().format("YYYY-MM-DD"),
    received_reject_detail: []
  }
  const methods = useForm<FormType>({
    defaultValues,
    resolver: yupResolver(validationSchema)
  })
  const onSubmit = (value: FormType) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.post(
          "/proreject/addreceivedreject",
          {
            ...value,
            reject_id: data?.reject_id,
            type_received: receiveType,
            vendor_id: data?.vendor_id,
            location_id: data?.location_id,
            address: data?.address
          }
        ),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.detail?.message ?? err.response.data.message
        }
      ).then(() => {
        navigate(`/purchase/transaction/record-reject/${id}`)
      }).catch(() => {
      }).finally(resolve)
    })
  }

  if (isLoading || !data) {
    return (
      <Loading
        errorText="No data available"
        loading={isLoading}
      />
    )
  }

  return (
    <div className="container my-5 flex flex-col gap-3">
      <FormProvider {...methods}>
        <FormSection data={data} />
      

        <FooterMenu
          hasCancelButton
          attachment={{ actiontype: "attachment" }}
          customElement={{
            journal:<Journal data={data}/>
          }}
          save={{
            actiontype: "save",
            loading: methods.formState.isSubmitting ? "true" : undefined,
            onClick: methods.handleSubmit(onSubmit)
          }}
        />
      </FormProvider>
    </div>
  )
}